module.exports = __webpack_public_path__ + "img/SQL Sync_old.07eae625.svg";